export type OptionsDrawerType = {
  name: string;
  pathRoute: string;
};

const CONFIGS_OPTIONS: OptionsDrawerType[] = [
  {
    name: "Tipos de pagamento",
    pathRoute: "/payment-types"
  },
  {
    name: "Tipos de serviço",
    pathRoute: "/service-types"
  },
  {
    name: "Formulários",
    pathRoute: "/forms"
  },
  {
    name: "Contas",
    pathRoute: "/accounts"
  }
];

export default CONFIGS_OPTIONS;
